export enum ServiceEnum {
  TALENT_CLOUD = 'TALENT_CLOUD',
  CREATIVE_OBJECTS = 'CREATIVE_OBJECTS',
}
